import React from 'react';
import { Penelope } from './pages/Penelope';
export function App() {
  return <Penelope data-id="element-0" />;
}